import { Latlong } from '../jobs/latlong';
import { Geolocation } from '../jobs/geolocation';

export class AlertConfigDetails {
  public textCriteria: string = '';
  public address: string = '';
  public remoteJobAvailability: boolean = false;
  public latLong: Latlong = new Latlong();
  public geoLocation: Geolocation = new Geolocation();
}
